(function(angular){
	'use strict';
	
	angular.module('highPerformanceHighPotentialChartModule', [
		'BaseConfig', 
		'highChartsModule'
	]);
	
})(window.angular);